/**
 * Formats a given numeric value as a currency string in euros.
 *
 * @param {number} value - The amount in cents that needs to be converted to euros and formatted.
 * @return {string} The formatted currency string in euros, adhering to Dutch locale conventions.
 */
export default function formatCurrency(value: number): string {
  // Convert from cents to euros
  const euros = value / 100

  return euros
    .toLocaleString('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    })
    .replace(/,00$/, ',-')
}
